import BaseEntity from '../base/BaseEntity.model';
import { TipoTramiteNota, TipoTramiteDocumento } from '.';
import ComponentDesignConfig from '../componentDesignConfig.model';
import ComponentImportConfig from '../componentImportConfig.model';
import EstadosParaCreacion from './EstadosParaCreacion.model'

export default class TipoTramite extends BaseEntity {
    public tipoTramitePadreId?: number;
    public requiereBeneficiario?: boolean;
    public seleccionable?: boolean;
    public psWeb?: boolean;
    public psOnline?: boolean;
    public psMobile?: boolean;
    public psOnlineMobile?: boolean;
    public activo?: boolean;
    public ciudadanoDisponibilidad?: string;
    public isParent?: boolean;
    public componentDesigned?: boolean;
    public componentImported?: boolean;
    public notas: TipoTramiteNota[] = [];
    public documentos: TipoTramiteDocumento[] = [];
    public estadosParaCreacion: EstadosParaCreacion[] = [];
    public componentDesignConfigId!: number;
    public componentDesignConfig!: ComponentDesignConfig | null;
    public componentImportConfigId!: number;
    public componentImportConfig!: ComponentImportConfig | null;

    
    constructor(
        public nombre?: string,
        public codigo?: string,
        public institucionId?: number,
        public descripcion?: string,
    ) { 
        super();
        this.init();
    }

    init(){
        this.id = undefined;
        this.tipoTramitePadreId = undefined;
        this.seleccionable = true;
        this.activo = true;
        this.requiereBeneficiario = false;
        this.componentDesigned = false;
        this.componentImported = false;
        this.notas = [];
        this.documentos = [];
        this.estadosParaCreacion = [];
        this.psWeb = true;
        this.psOnline = true;
        this.psMobile = true;
        this.psOnlineMobile = true;
        this.componentDesignConfig = null;
        this.componentImportConfig = null;
    }

    cancelContent(){
        this.componentImported = false;
        this.componentDesigned = false;
        this.componentDesignConfig = null;
        this.componentImportConfig = null;
    }
}